import React, { Component } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Collapse from '@material-ui/core/Collapse'

import BkFlowLanguageToggle from '../../../language/BkFlowLanguageToggle'
import BkFlowCurrencyToggle from '../../../currency/BkFlowCurrencyToggle'
import BkFlowNavigationProfile from '../profile/BkFlowNavigationProfile'
import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'

import yn from 'yn'

if (yn(process.env.REACT_APP_COMPONENT_NAVIGATION_UTILITY_BAR)) {
	require('../../../../styles/css/components/navigation/bk-flow-navigation-utility-bar.css')
}

class BkFlowNavigationUtilityBar extends Component  {
	constructor(props) {
		super(props);

		this.state = {
			previousScrollPosition: window.pageYOffset,
			isUtilityNavVisible: true
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll)
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll)
	}

	// Hide or show the menu.
	handleScroll = () => {
		const { previousScrollPosition } = this.state

		const currentScrollPosition = window.pageYOffset
		const visibility = previousScrollPosition > currentScrollPosition

		if (window.scrollY >= 50) {
			if (!visibility) {
				document.body.classList.add('utility-nav-hidden')
			} else {
				document.body.classList.remove('utility-nav-hidden')
			}

			this.setState({
				previousScrollPosition: currentScrollPosition,
				isUtilityNavVisible: visibility
			})
		}
	}

	render() {
		const {
			activeCurrencyData,
			exchangeRatesLoading,
			navBarBackground,
			navBarLogo,
		} = this.props
		const { isUtilityNavVisible } = this.state

		let loadingColor = '#000'

		if (yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)) {
			loadingColor = '#fff'
		}

		let navStyle = {}
		if (navBarBackground) {
			navStyle = { backgroundImage: `url(${navBarBackground})` }
		}

		return  (
			<Collapse
				in={ isUtilityNavVisible }
				timeout={ 300 }
			>
				<div className="bk-flow-navigation__utility-bar" style={navStyle}>
					{ navBarLogo && (
						<img className="bk-flow-nav-logo" alt="logo" src={navBarLogo} />
					)}

					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_LANGUAGE_TOGGLE) &&
						yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR) &&
						<BkFlowLanguageToggle />
					}

					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						exchangeRatesLoading ?
						<BkFlowMaterialLoader
							parentClasses='u-txt-center'
							color={loadingColor}
							size={15}
						/>
					: yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode ?
						<BkFlowCurrencyToggle
							isMobile={ false }
						/>
					:
						null
					}

					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
						<BkFlowNavigationProfile
							isUtilityNavVisible={isUtilityNavVisible}
						/>
					}
			</div>
			</Collapse>
		)
	}
}

function mapStateToProps(state) {
	return {
		navBarBackground: get(state, 'hotelContentFeeds.feeds.loyaltyAssets.assets.headerBackground'),
		navBarLogo: get(state, 'hotelContentFeeds.feeds.loyaltyAssets.assets.headerLogo'),
	}
}

const mapDispatchToProps = () => ({})
export default connect(mapStateToProps, mapDispatchToProps)(BkFlowNavigationUtilityBar)


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationUtilityBar.js